"use strict";
// (C) 2019-2020 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureFingerprint = void 0;
var tslib_1 = require("tslib");
var json_stable_stringify_1 = tslib_1.__importDefault(require("json-stable-stringify"));
var index_1 = require("./index");
var merge_1 = tslib_1.__importDefault(require("lodash/merge"));
var fingerprint_1 = require("../filter/fingerprint");
function simpleMeasureFingerprint(measure) {
    var _a;
    var measureDefinition = measure.measure.definition.measureDefinition;
    var measureDefinitionWithSanitizedFilters = tslib_1.__assign(tslib_1.__assign({}, measureDefinition), { filters: (_a = measureDefinition.filters) === null || _a === void 0 ? void 0 : _a.filter(fingerprint_1.isFilterRelevantForFingerprinting) });
    var measureDefinitionDefaults = {
        filters: [],
        computeRatio: false,
    };
    var measureDefinitionWithDefaults = merge_1.default(measureDefinitionDefaults, measureDefinitionWithSanitizedFilters);
    return json_stable_stringify_1.default({
        measure: tslib_1.__assign(tslib_1.__assign({}, measure.measure), { definition: {
                measureDefinition: measureDefinitionWithDefaults,
            } }),
    });
}
/**
 * Calculates dimension fingerprint; ensures that the optional vs default values are correctly reflected in
 * the fingerprint.
 *
 * @internal
 */
function measureFingerprint(measure) {
    if (index_1.isSimpleMeasure(measure)) {
        /*
         * Simple measure has a few optional properties, which, when not provided default to specific
         * values (aggregation, computeRatio etc).
         *
         * Fingerprinting simple measure thus requires normalization of the definition so that measure with
         * optional props not specified has same fingerprint as measure with optional props specified to default
         * values.
         */
        return simpleMeasureFingerprint(measure);
    }
    return json_stable_stringify_1.default(measure);
}
exports.measureFingerprint = measureFingerprint;
//# sourceMappingURL=fingerprint.js.map